import { BoxProps, Text } from "@chakra-ui/react";

import { NavItem } from "./config";

import { Link } from "ui";

export const navItemStyles: BoxProps = {
  cursor: "pointer",
  userSelect: "none",
  border: "1px",
  borderColor: "white",
  borderRadius: "base",
  fontSize: "md",
  fontWeight: "normal",
  width: "100%",
  py: 1,
  _focus: {
    outline: "none !important",
  },
  _focusVisible: {
    outline: "none",
    boxShadow: "outline",
  },
};

type NavLinkProps = {
  item: NavItem;
  isActive: boolean;
  path: string;
  subNavLeftPadding: number;
  toggle?: () => void;
};

export function NavLink({
  item,
  isActive,
  path,
  subNavLeftPadding,
  toggle,
}: NavLinkProps) {
  return (
    <Link
      href={item.href ?? path}
      display="flex"
      minHeight="32px"
      alignItems="center"
      color={isActive ? "primary.base" : "text.secondary"}
      bg={isActive ? "primary.background" : "transparent"}
      transition="150ms all ease-in-out"
      _hover={{ bg: isActive ? "primary.background" : "base.background" }}
      _active={{ color: isActive ? "primary.base" : "text.secondary" }}
      onClick={toggle}
    >
      <Text
        as="span"
        alignContent="center"
        lineHeight="20px"
        minHeight="32px"
        pl={subNavLeftPadding}
        {...navItemStyles}
      >
        {item.label}
      </Text>
    </Link>
  );
}
